import { CSSProperties, ReactNode } from 'react'

import { CssBaseline, buttonClasses } from '@mui/material'
import GlobalStyles from '@mui/material/GlobalStyles'
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles'
import { ThemeProvider as StylesThemeProvider } from '@mui/styles'

import theme from '../theme'

const forcedStyles = (styleObject: CSSProperties) =>
  Object.entries(styleObject).reduce(
    (importantStyle, [key, value]) => ({ ...importantStyle, [key]: `${value} !important` }),
    {} as CSSProperties
  )

const ThemeProvider = ({ children }: { children: ReactNode }) => {
  return (
    <MuiThemeProvider theme={theme}>
      <StylesThemeProvider theme={theme}>
        <CssBaseline />
        <GlobalStyles
          styles={{
            [`.${buttonClasses.root}`]: {
              ...forcedStyles(theme.typography['Sarabun Button']),
            },
          }}
        />
        {children as React.ReactNode}
      </StylesThemeProvider>
    </MuiThemeProvider>
  )
}

export default ThemeProvider
